import { FlexColumn } from '@/shared/ui/Layouts/Flex';
import React from 'react'
import "./ShowDetail.scss";

interface IShowDetail extends React.DetailedHTMLProps<React.HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
    title: string;
    record: any;
    children: JSX.Element[];
}

function ShowDetail({title, record, children, ...props}: IShowDetail) {
    const {style: propStyle, className: propClassName, ...restProps} = props
    return (
        <FlexColumn
            className={`ShowDetail ${propClassName || ""}`}
            style={{
                width: "100%",
                height: "100%",
                gap: "15px",
                justifyContent: "flex-start",
                alignItems: "flex-start",
                flexWrap: "wrap",
                ...propStyle
            }}
            {...restProps}
        >
        {children.map((element: any) => (
            <FlexColumn
                className='ShowDetailField'
                id={record.id}
                style={{
                    gap: "5px",
                    justifyContent: "flex-start",
                    alignItems: "flex-start"
                }}
            >
                {element.props.label && <span>{element.props.label}</span>}
                {React.cloneElement(element, { value: record[element.key] || element.empty || "--", record: record })}
            </FlexColumn>
        ))}
        </FlexColumn>
    )
}

export default ShowDetail